export default __webpack_public_path__ + "static/media/ars-maquette-medium-webfont.f8026859.eot";